import { z } from 'zod'

export const ADMINSOLOSESSIONSPOST_CONTRACT_VERSION = '1.0.0' as const
export const adminSoloSessionsPostResponseSchema = z.unknown()
export type AdminSoloSessionsPostResponse = z.infer<typeof adminSoloSessionsPostResponseSchema>
